import { AppointmentTypeDTO } from '@/data/DTOs/schedule/AppointmentTypeDTO';
import { handleRequestError, useRestClient } from '../useRestClient';
import {
  SCHEDULE_APPOINTMENT_TYPE_URL,
  SCHEDULE_LOCATIONS_URL,
} from '@/constants/constants';
import { LocationDTO } from '@/data/DTOs/schedule/LocationDTO';
import { useMemo } from 'react';

export function useAppointmentTypeService() {
  const { restClient } = useRestClient();

  const getAppointmentTypeList = async (): Promise<AppointmentTypeDTO[]> => {
    try {
      const response = await restClient.get(SCHEDULE_APPOINTMENT_TYPE_URL);
      return response.data;
    } catch (error) {
      throw handleRequestError(error);
    }
  };

  const getLocationList = async (): Promise<LocationDTO[]> => {
    try {
      const response = await restClient.get(SCHEDULE_LOCATIONS_URL);
      return response.data;
    } catch (error) {
      throw handleRequestError(error);
    }
  };

  return useMemo(
    () => ({
      getAppointmentTypeList,
      getLocationList,
    }),
    []
  );
}
